/**
 * Clears localStorage while preserving costings-backup keys.
 * Drop-in replacement for localStorage.clear() — all other data is wiped as normal.
 */
export function safeClearLocalStorage() {
    // Collect costings backups before clearing
    const costingsBackups: Record<string, string> = {};
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('costings-backup:')) {
            costingsBackups[key] = localStorage.getItem(key) || '';
        }
    }

    // Clear everything
    localStorage.clear();

    // Restore costings backups
    for (const [key, value] of Object.entries(costingsBackups)) {
        localStorage.setItem(key, value);
    }
}
